module.exports = __webpack_public_path__ + "img/violet_060.fd63d3f6.png";